import { toast } from "sonner";
import { api } from "@/lib/api";
import { Plus, MessageSquare, Pencil, Trash2 } from "lucide-react";

export default function ConversationList({ conversations, currentId, onSelect, onNew, onChanged }) {
  const rename = async (e, c) => {
    e.stopPropagation();
    const title = window.prompt("Novo nome da conversa:", c.title);
    if (!title?.trim()) return;
    try {
      await api.patch(`/conversations/${c.id}`, { title: title.trim() });
      onChanged?.();
    } catch { toast.error("Não consegui renomear a conversa."); }
  };
  const remove = async (e, c) => {
    e.stopPropagation();
    if (!window.confirm("Excluir esta conversa?")) return;
    await api.delete(`/conversations/${c.id}`);
    toast.success("Conversa excluída.");
    onChanged?.(c.id);
  };

  return (
    <div className="flex flex-col h-full">
      <button onClick={onNew} data-testid="new-conversation-btn"
        className="flex items-center justify-center gap-2 rounded-full bg-[#5B6E5B] px-4 py-2.5 text-sm text-[#FDFBF7] hover:bg-[#4A5D4E] transition-colors">
        <Plus className="w-4 h-4" /> Nova conversa
      </button>
      <div className="mt-3 flex-1 overflow-y-auto space-y-1 pr-1">
        {conversations.length === 0 && <p className="font-body text-xs text-[#A8B0A2] px-2 py-3">Nenhuma conversa ainda.</p>}
        {conversations.map((c) => (
          <div key={c.id} onClick={() => onSelect(c.id)} data-testid="conversation-item"
            className={`group flex items-center gap-2 rounded-xl px-3 py-2.5 cursor-pointer transition-colors ${currentId === c.id ? "bg-[#5B6E5B]/12" : "hover:bg-[#F5F0E6]"}`}>
            <MessageSquare className="w-4 h-4 text-[#5B6E5B] shrink-0" />
            <span className="flex-1 min-w-0 truncate font-body text-sm text-[#2C332A]">{c.title}</span>
            <button onClick={(e) => rename(e, c)} data-testid="conversation-rename" className="opacity-0 group-hover:opacity-100 text-[#7A8A7A] hover:text-[#2C332A] transition-opacity"><Pencil className="w-3.5 h-3.5" /></button>
            <button onClick={(e) => remove(e, c)} data-testid="conversation-delete" className="opacity-0 group-hover:opacity-100 text-[#C87A5E] hover:text-[#B2644D] transition-opacity"><Trash2 className="w-3.5 h-3.5" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
